export default {
    acl: []
};
